<template>
  <div class="certification-page" v-slideIn>
    <div class="page-head-container">
      <PageHead pageName="资质认证" />
    </div>
    <Steps :current="3" />
    <div class="page-wrapper">
      <div class="page-empty" v-if="loading" v-loading.lock="loading"></div>
      <template v-else>
        <div class="form-area">
          <status-info :certification="certification" v-if="auditStatus" />
          <div class="form-block">
            <h3 class="head">个人信息</h3>
            <div class="form-item">
              <span
                class="form-item-label"
                :class="[isReadonly ? '' : 'form-item-label--required']"
                >身份证人像面:</span
              >
              <div
                class="form-item-inner form-item-inner--imgs"
                v-if="isReadonly"
              >
                <div class="form-item-inner--imgs-item">
                  <img :src="certification.identityCardFrontUrl" />
                </div>
              </div>
              <div
                class="form-item-inner form-item-inner--mutiiple-line"
                v-else
              >
                <Upload
                  :url="userInfo.identityCardFrontUrlPreview"
                  :onRemove="handleFrontPictureRemove"
                  :onSuccess="handleFrontPictureChange"
                  :action="uploadApi"
                  :beforeUpload="beforeUpload"
                  :error="userInfoErrors.identityCardFrontUrl"
                />
              </div>
            </div>
            <div class="form-item">
              <span
                class="form-item-label"
                :class="[isReadonly ? '' : 'form-item-label--required']"
              >
                身份证国徽面:
              </span>
              <div
                class="form-item-inner form-item-inner--imgs"
                v-if="isReadonly"
              >
                <div class="form-item-inner--imgs-item">
                  <img :src="certification.identityCardBackUrl" />
                </div>
              </div>
              <div
                class="form-item-inner form-item-inner--mutiiple-line"
                v-else
              >
                <Upload
                  :url="userInfo.identityCardBackUrlPreview"
                  :onRemove="handleBackPictureRemove"
                  :onSuccess="handleBackPictureChange"
                  :action="uploadApi"
                  :beforeUpload="beforeUpload"
                  :error="userInfoErrors.identityCardBackUrl"
                />
              </div>
            </div>
            <div class="form-item">
              <span
                class="form-item-label"
                :class="[isReadonly ? '' : 'form-item-label--required']"
              >
                姓名:
              </span>
              <div
                class="form-item-inner form-item-inner--text"
                v-if="isReadonly"
              >
                {{ certification.username }}
              </div>
              <div class="form-item-inner" v-else>
                <Input
                  :inline="true"
                  maxlength="20"
                  type="text"
                  v-model="userInfo.username"
                  :error="userInfoErrors.username"
                  :onBlur="handleUserInfoValidate('username')"
                />
              </div>
            </div>
            <div class="form-item">
              <span
                class="form-item-label"
                :class="[isReadonly ? '' : 'form-item-label--required']"
              >
                身份证号:
              </span>
              <div
                class="form-item-inner form-item-inner--text"
                v-if="isReadonly"
              >
                {{ certification.idCardNo }}
              </div>
              <div class="form-item-inner" v-else>
                <Input
                  :inline="true"
                  maxlength="18"
                  type="text"
                  v-model="userInfo.idCardNo"
                  :error="userInfoErrors.idCardNo"
                  :onBlur="handleUserInfoValidate('idCardNo')"
                />
              </div>
            </div>
            <div class="form-item">
              <span
                class="form-item-label"
                :class="[isReadonly ? '' : 'form-item-label--required']"
              >
                身份证有效期:
              </span>
              <div
                class="form-item-inner form-item-inner--text"
                v-if="isReadonly"
              >
                <!-- <template v-if="isMaxDate">
                  {{ +certification.idCardValidTime | formatDate }} - 长期
                </template> -->
                <template>
                  {{ +certification.idCardValidTime | formatDate }} -
                  {{ +certification.idCardExpirationTime | formatDate }}
                </template>
              </div>
              <div class="form-item-inner" v-else>
                <el-date-picker
                  style="width: 300px"
                  type="daterange"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                  v-model="userInfo.idCardExpiryDate"
                  @change="handleExpiryChange"
                  format="yyyy-MM-dd"
                  value-format="timestamp"
                  size="medium"
                  v-show="!isInfinite"
                />
                <el-date-picker
                  v-show="isInfinite"
                  placeholder="开始日期"
                  style="width: 150px"
                  :value="
                    userInfo.idCardExpiryDate && userInfo.idCardExpiryDate[0]
                  "
                  @input="handleIdCardValidTimeChange"
                  format="yyyy-MM-dd"
                  value-format="timestamp"
                  size="medium"
                />
                <!-- 因为这里element-ui遵循的date格式化日期标准和dayjs不一样，所以这里的yyyy-MM-dd和formatDate方法里面的格式不一样 -->
                <p
                  class="form-item-inner--error"
                  v-if="userInfoErrors.idCardExpiryDate"
                >
                  {{ userInfoErrors.idCardExpiryDate }}
                </p>
              </div>
              <span v-if="isInfinite && !isReadonly" class="sprate"> - </span>
              <span class="form-item-extra" v-if="!isReadonly"
                ><Checkbox
                  label="长期"
                  v-model="isInfinite"
                  :onChange="handleChangeIdCardType"
              /></span>
            </div>
          </div>
        </div>
        <div class="form-buttons">
          <span class="btn-container">
            <Button type="hollow-red" text="上一步" :onClick="goBack" />
          </span>
          <span class="btn-container">
            <Button
              text="确定提交"
              type="danger"
              :onClick="handleSubmit"
              :disabled="submitting"
              :loading="submitting"
            />
          </span>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import uniq from 'lodash/uniq';
import Steps from '@/components/Steps/index.vue';
import PageHead from '@/components/PageHead/index.vue';
import Input from '@/components/Input/index.vue';
import Button from '@/components/Button/index.vue';
import Message from '@/components/Message';
import Upload from '@/components/Upload/index.vue';
import Checkbox from '@/components/Checkbox';
import StatusInfo from '../status';

import api from '@/api';
import env from '@/utils/env';
import { mixins } from '@/utils';
import {
  routes,
  platformCode,
  indentityCode,
  additionalCertRules,
  certificationStatusCode,
  openningAndOpenedStatus,
  userInfoRules,
  maxDateTimestamp,
} from '@/config';
import dayjs from 'dayjs';

export default {
  name: 'edit-personal-certification',
  data() {
    return {
      submitting: false,
      loading: true,
      hasCert: false,
      hasReject: false,
      auditStatus: null,
      certification: {},
      idCardValidTime: null,
      userInfo: {
        identityCardFrontUrl: '',
        identityCardFrontUrlPreview: '',
        identityCardBackUrl: '',
        identityCardBackUrlPreview: '',
        username: '',
        idCardNo: '',
        idCardExpiryDate: [],
      },
      userInfoErrors: {
        identityCardFrontUrl: '',
        identityCardBackUrl: '',
        username: '',
        idCardNo: '',
        idCardExpiryDate: '',
      },
      token: localStorage.getItem('sso_biz_token'),
      uploadingFileCounts: 0,
      uploadApi: api.getUploadApi(),
      isInfinite: false,
    };
  },
  mixins: [mixins],
  created() {
    setTimeout(() => {
      let baseTitle = JSON.parse(localStorage.getItem('WEB_INFO')).title || '';
      document.title = `${baseTitle} - 资质认证`;
    }, 500);
  },
  methods: {
    handleFrontPictureChange(res) {
      if (res.code === 0) {
        this.uploadingFileCounts--;
        this.userInfo.identityCardFrontUrl = res.data.url;
        this.userInfoErrors.identityCardFrontUrl = '';
      }
    },
    handleFrontPictureRemove() {
      this.userInfo.identityCardFrontUrl = '';
      this.userInfoErrors.identityCardFrontUrl = '请上传身份证人像面';
    },
    handleBackPictureChange(res) {
      if (res.code === 0) {
        this.uploadingFileCounts--;
        this.userInfo.identityCardBackUrl = res.data.url;
        this.userInfoErrors.identityCardBackUrl = '';
      }
    },
    handleBackPictureRemove() {
      this.userInfo.identityCardBackUrl = '';
      this.userInfoErrors.identityCardBackUrl = '请上传身份证国徽面';
    },
    beforeUpload(file) {
      if (!/^image\//.test(file.type)) {
        Message.error('只能上传图片文件');
        return false;
      }
      if (file.size > 1024 * 1024 * 10) {
        Message.error('文件大小不能超过10M');
        return false;
      }
      this.uploadingFileCounts++;
      return true;
    },
    handleUserInfoValidate(name) {
      return this.validateFieldWithErrors(
        this.userInfoErrors,
        userInfoRules,
        name
      );
    },
    handleExpiryChange(value) {
      if (!value) {
        this.userInfoErrors.idCardExpiryDate = '请选择身份证有效期';
      } else {
        this.userInfoErrors.idCardExpiryDate = '';
      }
    },
    validateUserInfo() {
      const { isValid, errors } = this.validateFields(
        this.userInfo,
        userInfoRules
      );
      this.userInfoErrors = errors;
      return isValid;
    },
    validateFileUploadComplete() {
      if (this.uploadingFileCounts !== 0) {
        Message.warning('请等待文件上传完毕再提交');
        return false;
      }
      return true;
    },
    validate() {
      const validResult = [this.validateFileUploadComplete()];
      if (!this.isReadonly) {
        validResult.push(this.validateUserInfo());
      }
      return validResult.every((result) => result);
    },
    createSubmitData() {
      const {
        username,
        idCardNo,
        identityCardFrontUrl,
        identityCardBackUrl,
        idCardExpiryDate,
      } = this.userInfo;
      // eslint-disable-next-line array-bracket-spacing
      const [idCardValidTime, idCardExpirationTime] = idCardExpiryDate || [];
      const returnValue = {
        platformList: this.platformCodeAndIdentityCode,
        individualBaseCertInfo: {
          username,
          idCardNo,
          identityCardFrontUrl,
          identityCardBackUrl,
          idCardValidTime,
          idCardExpirationTime,
        },
      };
      if (this.isReadonly) {
        delete returnValue.individualBaseCertInfo;
      }
      return returnValue;
    },
    handleSubmit() {
      const isValid = this.validate();
      if (!isValid) {
        return;
      }
      const data = this.createSubmitData();

      this.$confirm('确定立即提交吗？', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        this.submitting = true;
        return api.addPersonCert(data).then((res) => {
          this.submitting = false;
          if (res.code === 0) {
            this.$message.success('提交成功');
            this.goPlatformIndex();
          }
        });
      });
    },
    goBack() {
      this.$router.replace({
        path: `${routes.chooseService}/${routes.choosePersonal.path}`,
      });
    },
    goPlatformIndex() {
      this.$router.replace({
        path: routes.platformIndex,
        params: this.$route.params,
        query: {
          ...this.$route.query,
          platformList: this.selectedPlatformList.join(','),
        },
      });
    },
    fetchDetail() {
      return api.getPersonalCertInfo().then((res) => {
        if (res.code === 0) {
          const data = res.data;
          this.certification = data;
          this.auditStatus = data.auditStatus;
          if (!data.auditStatus) {
            return;
          }
          this.userInfo = {
            identityCardFrontUrl: this.certification.identityCardFrontKey,
            identityCardFrontUrlPreview: this.certification
              .identityCardFrontUrl,
            identityCardBackUrl: this.certification.identityCardBackKey,
            identityCardBackUrlPreview: this.certification.identityCardBackUrl,
            username: this.certification.username,
            idCardNo: this.certification.idCardNo,
            idCardExpiryDate: [
              this.certification.idCardValidTime,
              this.certification.idCardExpirationTime,
            ],
          };
          if (this.certification.idCardExpirationTime === maxDateTimestamp) {
            this.isInfinite = true;
          }
        }
      });
    },
    handleChangeIdCardType(checked) {
      if (checked) {
        this.userInfo.idCardExpiryDate = ['', maxDateTimestamp];
      } else {
        this.userInfo.idCardExpiryDate = [];
      }
      this.isInfinite = checked;
    },
    handleIdCardValidTimeChange(value) {
      this.userInfo.idCardExpiryDate = [value, maxDateTimestamp];
      this.userInfoErrors.idCardExpiryDate = '';
    },
    async init() {
      this.loading = true;
      await this.fetchDetail();
      this.loading = false;
    },
  },
  computed: {
    selectedPlatformList() {
      const platformList = this.$route.query.platformList;
      return platformList ? platformList.split(',') : [];
    },
    selectedIdentityList() {
      const identityList = this.$route.query.identityList;
      return identityList ? identityList.split(',') : [];
    },
    platformCodeAndIdentityCode() {
      const platformList = this.selectedPlatformList;
      const identityList = this.selectedIdentityList;

      return platformList
        .map((platformCode) => {
          return {
            platformCode,
            identityList: identityList.filter(
              (code) => code.indexOf(platformCode) !== -1
            ),
          };
        })
        .filter((el) => {
          return el.identityList.length;
        });
    },
    // 如果是开通审核中或者已开通，则代表为只读，不可修改资质信息
    isReadonly() {
      return (
        this.auditStatus === certificationStatusCode.openning ||
        this.auditStatus === certificationStatusCode.opened
      );
    },
    isMaxDate() {
      return (
        +dayjs(+this.certification.idCardExpirationTime) === maxDateTimestamp
      );
    },
  },
  mounted() {
    this.init();
  },
  components: {
    Steps,
    Input,
    Button,
    Upload,
    PageHead,
    Checkbox,
    StatusInfo,
  },
};
</script>
<style lang="scss" scoped>
@import '../style';
</style>
